import React, {useContext} from 'react';
import { QuoteInterface, ConfirmationProps } from "./Confirmation.types";
import './confirmation.scss'
// import { EMAIL_QUOTE } from "app/queries/EmailQuote";
import {useMutation, useQuery} from "@apollo/react-hooks";
import {ExecutionResult} from "graphql";
import {toast} from "react-toastify";
import moment from 'moment'
import {GET_CONFIG} from "app/queries/Config";

export function Confirmation(props: ConfirmationProps) {
  const { pickUpAddress, dropOffAddress, groupSize, quote } = props;
  const { distanceInMiles, quoteAmount } = quote.calculateQuote;
  // const [ emailQuote ] = useMutation(EMAIL_QUOTE);
  const getConfig: any = useQuery(GET_CONFIG);
  const config = getConfig.data?.config;

  // async function submitQuote() {
  //   const timeStamp: string | undefined = localStorage.getItem('submissionStamp') ?? undefined;
  //   let submissionAllowed: boolean = true;
  //   if(timeStamp) {
  //     const lastSubmitted = moment(timeStamp);
  //     if(!lastSubmitted.isBefore(moment().subtract(30, 'minutes'))) submissionAllowed = false
  //   }
  //   if(submissionAllowed) {
  //     try{
  //       const response: ExecutionResult<QuoteInterface> = await emailQuote({
  //         variables: {
  //           id: quote.calculateQuote.id
  //         }
  //       });
  //       localStorage.setItem('submissionStamp', moment().format())
  //       window.location.href = 'https://www.lakeozarkswatertaxi.com/thank-you-ride-request'
  //     } catch(e) {
  //       toast.warn('Something went wrong sending quote, please try again.')
  //     }
  //   } else {
  //     toast.warn(<>You have already submitted a quote in the last 30 minutes. If there was a mistake in your quote, please text dispatch at <a href={`tel:'${573-880-8294}`}>573-880-8294</a></>)
  //   }

  // }

  const writeQuoteDetail = (label: string, value: string | number, message: string = '') => (
      <div className='row quote-item'>
        <div className='col-12 col-md-6 text-left text-md-right quote-label'>
          {label}:
        </div>
        <div className='col-12 col-md-6 text-left quote-value'>
          {value}
        </div>
        {
          message.length > 0 &&
          <div className='col-12 text-center quote-message'>
            {message}
          </div>
        }
      </div>
  )
  const requestRideMessage = config.requestRideMessage ?? 'SEND BOAT NOW';

  return (
      <>
        <div className='col-12'>
          <div className='quote'>
            {writeQuoteDetail('Pick Up Address', pickUpAddress)}
            {writeQuoteDetail('Drop Off Address', dropOffAddress)}
            {writeQuoteDetail('Distance', `${distanceInMiles.toFixed(1)} miles`)}
            {writeQuoteDetail('Passengers', groupSize)}
            {writeQuoteDetail('Price Per Person', `$${Math.round(Number(quoteAmount) / Number(groupSize))} one way`, '*Please note this is just an estimate. Mileage charge will be based on actual miles driven on the water.')}
          </div>
        </div>
        <div className='col-12 mt-4 mb-2 text-center confirm-btns'>
          <span className='btn btn-white0 ml-md-2' onClick={() => props.onReset(false)}>GET NEW QUOTE</span>
        </div>
      </>
  )
}
